import { atom, useAtom } from 'jotai';

export enum EditEmailModalMode {
  EnterEmail = 'enter-email',
  EmailSubmitted = 'email-submitted',
  TokenVerificationProgressing = 'token-verification-progressing',
  TokenVerificationSuccess = 'token-verification-success',
  TokenVerificationError = 'token-verification-error',
  Empty = '',
}

const modeAtom = atom<EditEmailModalMode>(EditEmailModalMode.Empty);
const openEmailModalAtom = atom<boolean>(false);
const submittedEmailAtom = atom<string>('');

export function useEditEmailForm() {
  const [mode, setMode] = useAtom(modeAtom);
  const [openEmailModal, setOpenEmailModal] = useAtom(openEmailModalAtom);
  const [submittedEmail, setSubmittedEmail] = useAtom(submittedEmailAtom);

  return {
    mode,
    setMode,
    openEmailModal,
    setOpenEmailModal,
    open: openEmailModal,
    onClose: () => {
      setOpenEmailModal(false);
      setTimeout(() => {
        setSubmittedEmail('');
        setMode(EditEmailModalMode.Empty);
      }, 300);
    },
    onOpen: () => {
      setMode(EditEmailModalMode.EnterEmail);
      setOpenEmailModal(true);
    },
    submittedEmail,
    setSubmittedEmail,
  };
}
